// ══════════════════════════════════════════════════════════════
// COMPASS – Toast Actions (fire-and-forget, no reducer)
// ══════════════════════════════════════════════════════════════
import { createActionGroup, props } from '@ngrx/store';
import { NotificationType } from '../../../shared/notifications/notification.model';

export const ToastActions = createActionGroup({
  source: 'Toast',
  events: {
    'Show Toast': props<{
      message: string;
      messageParams?: Record<string, unknown>;
      title?: string;
      notificationType: NotificationType;
      duration?: number;
      showClose?: boolean;
      action?: { label: string; callback: () => void };
    }>(),
  },
});
